import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';

import { takeUntil, tap } from 'rxjs/operators';
import { TitleService } from '~shared/services/title.service';
import { Seller, Tab } from '../models';
import * as fromSeller from '../store';
import { LoadSeller } from '../store/seller';

@Component({
  selector: 'app-storefront-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss'],
})
export class SellerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<boolean>();

  tabs$: Observable<Tab[]>;
  seller$: Observable<Seller>;

  constructor(
    private readonly store: Store<fromSeller.State>,
    private readonly route: ActivatedRoute,
    private readonly titleService: TitleService
  ) {}

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params['id'];
      this.store.dispatch(new LoadSeller({ id }));
    });

    this.tabs$ = this.store.pipe(select(fromSeller.generateTabs));

    this.seller$ = this.store.pipe(
      select(fromSeller.getSellerPayload),
      tap((seller: Seller) => {
        if (!!seller?.shopName) {
          this.addBrowserTabTitle(seller.shopName);
        }
      })
    );
  }

  private addBrowserTabTitle(title: string): void {
    this.titleService.setTitle([title, { title: 'TITLE.PAGE.SELLER' }]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
